import { Tooltip } from '@genial/components';
import { Stack } from 'native-base';
import React, { useMemo } from 'react';

import { CustomerDetailFullAccount } from '../../../../../../../store/customerDetail/types';
import { getBlockStatusTooltip } from '../../constants';

export namespace BlockStatusTooltipTypes {
  export type Props = {
    children: React.ReactElement;
    customer?: CustomerDetailFullAccount | null;
    isLoading?: boolean;
    hasError?: boolean;
    tooltipMessage?: string;
  };
}

export const BlockStatusTooltip: React.FC<BlockStatusTooltipTypes.Props> = ({
  children,
  customer,
  isLoading,
  hasError,
  tooltipMessage: tooltipMessageProp,
}) => {
  const tooltipMessage = useMemo(() => {
    if (tooltipMessageProp !== undefined) {
      return tooltipMessageProp;
    }

    return getBlockStatusTooltip(customer, !!isLoading, !!hasError);
  }, [customer, hasError, isLoading, tooltipMessageProp]);

  if (!tooltipMessage) {
    return children;
  }

  return (
    <Tooltip label={tooltipMessage}>
      <Stack>{children}</Stack>
    </Tooltip>
  );
};
